import React, { useCallback, useEffect, useMemo, useState,useRef, useContext } from 'react'; 
import HomeContent from './PlanDetail' 
import useDelayShow from '../../hooks/useDelayShow'; 

const Home: React.FC = () => { 
  const show = useDelayShow()
  return show && <HomeContent/>
};
 

export default Home;
